import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const getPlatformServicesByProfession = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.SERVICES.PLATFORM_SERVICES);
        return response.data; // return the array of platform services
    } catch (error) {
        console.error("Error fetching platform services:", error);
        throw error; // Re-throw for the caller to handle
    }
};

export const createProfileService = async (payload) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.SERVICES.PROFILE_SERVICE_CREATE,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error creating profile service:", error);
    throw error;
  }
};

export const getProfileServices = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.SERVICES.PROFILE_SERVICES_LIST);
        return response.data; // returns array of profile services for the user
    } catch (error) {
        console.error("Error fetching profile services:", error);
        throw error;
    }
};

// Delete a profile service
export const deleteProfileService = async (id) => {
    try {
        const response = await apiClient.delete(API_ENDPOINTS.SERVICES.PROFILE_SERVICE_DETAIL(id));
        return response.data;
    } catch (error) {
        console.error(`Error deleting profile service ${id}:`, error);
        throw error;
    }
};


export const updateProfileService = async (serviceId, payload) => {
    try {
        const response = await apiClient.patch(
            API_ENDPOINTS.SERVICES.PROFILE_SERVICE_DETAIL(serviceId),
            payload
        );
        return response.data; // returns updated service object
    } catch (error) {
        console.error(`Error updating profile service ${serviceId}:`, error);
        throw error;
    }
};

export const fetchPublicServices = async (profileId) => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.SERVICES.PROFILE_SERVICES(profileId));
        return response.data;
    } catch (error) {
        console.error("Error fetching public services:", error);
        throw error;
    }
};